// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607201934/js/" + chunkId + "." + {"44":"6cc4a0cc","225":"31dff83f","481":"4768a076","486":"6924dc99","770":"9905e617"}[chunkId] + ".0.048498907191647955.chunk.js";
};